import { render, staticRenderFns } from "./payment_item.vue?vue&type=template&id=5bdceac0&scoped=true"
import script from "./payment_item.vue?vue&type=script&lang=js"
export * from "./payment_item.vue?vue&type=script&lang=js"
import style0 from "./payment_item.vue?vue&type=style&index=0&id=5bdceac0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdceac0",
  null
  
)

export default component.exports